module.exports = __webpack_public_path__ + "produce-fresh-grass-08.jpg?4718e92d07e312f67b83aee5637a947b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-08.jpg
// module id = 45
// module chunks = 0